import { replacePathParams } from '@/api/utils';

export const offerApiPaths = {
  list: '/offerservice/offers',
  byId: '/offerservice/offers/:offerId',
  create: '/offerservice/offers',
  update: '/offerservice/offers/:offerId',
  accept: '/offerservice/offers/:offerId/accept',
  decline: '/offerservice/offers/:offerId/decline',
  erroneous: '/offerservice/offers/:offerId/mark-erroneous',
  rollback: '/offerservice/offers/:offerId/rollback',
  acceptedForNop: '/offerservice/offers/:offerId/accept-for-nop',
  present: '/offerservice/offers/:offerId/present',
  acceptAhead: '/offerservice/offers/:offerId/accept-ahead',
  autoRuleOut: '/offerservice/offers/:offerId/auto-rule-out',
  close: '/offerservice/offers/:offerId/close',
  files: '/offerservice/offers/:offerId/files',
  fileById: '/offerservice/offers/:offerId/files/:fileId',
  links: '/offerservice/offers/:offerId/links',
  linkById: '/offerservice/offers/:offerId/links/:linkId',
  notes: '/offerservice/offers/:offerId/notes',
  noteById: '/offerservice/offers/:offerId/notes/:noteId',
  notePin: '/offerservice/offers/:offerId/notes/:noteId/pin',
  noteUnpin: '/offerservice/offers/:offerId/notes/:noteId/unpin',
  donorInformation: '/offerservice/offers/:offerId/donor-information',
  disposition: '/offerservice/offers/:offerId/disposition',
  clone: '/offerservice/offers/:offerId/clone',
  donorSummaryUploadUrl: '/offerservice/offers/:offerId/donor-summary/upload-url',
  donorSummary: '/offerservice/offers/:offerId/donor-summary',
  donorSummaryParse: '/offerservice/offers/:offerId/donor-summary/parse',
  donorSummaryParseById: '/offerservice/offers/:offerId/donor-summary/parse/:parseId',
  refusalCodes: '/offerservice/refusal-codes',
  buildInfo: '/offerservice/build-info',
} as const;

export const getOfferApiUrl = {
  list: () => offerApiPaths.list,
  byId: (offerId: string) => replacePathParams(offerApiPaths.byId, { offerId }),
  create: () => offerApiPaths.create,
  update: (offerId: string) => replacePathParams(offerApiPaths.update, { offerId }),
  accept: (offerId: string) => replacePathParams(offerApiPaths.accept, { offerId }),
  decline: (offerId: string) => replacePathParams(offerApiPaths.decline, { offerId }),
  erroneous: (offerId: string) => replacePathParams(offerApiPaths.erroneous, { offerId }),
  rollback: (offerId: string) => replacePathParams(offerApiPaths.rollback, { offerId }),
  acceptedForNop: (offerId: string) => replacePathParams(offerApiPaths.acceptedForNop, { offerId }),
  present: (offerId: string) => replacePathParams(offerApiPaths.present, { offerId }),
  acceptAhead: (offerId: string) => replacePathParams(offerApiPaths.acceptAhead, { offerId }),
  autoRuleOut: (offerId: string) => replacePathParams(offerApiPaths.autoRuleOut, { offerId }),
  close: (offerId: string) => replacePathParams(offerApiPaths.close, { offerId }),
  files: (offerId: string) => replacePathParams(offerApiPaths.files, { offerId }),
  fileById: (offerId: string, fileId: string) => replacePathParams(offerApiPaths.fileById, { offerId, fileId }),
  links: (offerId: string) => replacePathParams(offerApiPaths.links, { offerId }),
  linkById: (offerId: string, linkId: string) => replacePathParams(offerApiPaths.linkById, { offerId, linkId }),
  notes: (offerId: string) => replacePathParams(offerApiPaths.notes, { offerId }),
  noteById: (offerId: string, noteId: string) => replacePathParams(offerApiPaths.noteById, { offerId, noteId }),
  notePin: (offerId: string, noteId: string) => replacePathParams(offerApiPaths.notePin, { offerId, noteId }),
  noteUnpin: (offerId: string, noteId: string) => replacePathParams(offerApiPaths.noteUnpin, { offerId, noteId }),
  donorInformation: (offerId: string) => replacePathParams(offerApiPaths.donorInformation, { offerId }),
  disposition: (offerId: string) => replacePathParams(offerApiPaths.disposition, { offerId }),
  clone: (offerId: string) => replacePathParams(offerApiPaths.clone, { offerId }),
  donorSummaryUploadUrl: (offerId: string) => replacePathParams(offerApiPaths.donorSummaryUploadUrl, { offerId }),
  donorSummary: (offerId: string) => replacePathParams(offerApiPaths.donorSummary, { offerId }),
  donorSummaryParse: (offerId: string) => replacePathParams(offerApiPaths.donorSummaryParse, { offerId }),
  donorSummaryParseById: (offerId: string, parseId: string) =>
    replacePathParams(offerApiPaths.donorSummaryParseById, { offerId, parseId }),
  refusalCodes: () => offerApiPaths.refusalCodes,
  buildInfo: () => offerApiPaths.buildInfo,
};
